'use client'

import { memo } from 'react'

import { ErrorServiceUnavailable } from '@/components/common/Error'

const VaultConfigurationError = () => {
  return <ErrorServiceUnavailable minHeight="100px" />
}

export default memo(VaultConfigurationError)
